const HomePage: React.FC = (): React.ReactElement => {
  return (
    <div className="container mt-3">
      <p>Este sistema é responsável pela comunicação de dados de pessoal entre o MPPB e o CNMP.</p>
    </div>
  );
};

export default HomePage;
